import { Flex, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { COMMON_WEB_PATH } from '@/constant';
import useCheckLogin from '@/hook/useCheckLogin';
import { gradientStyle } from '@/utils/styles.utils';

const UidBanner = () => {
  const { isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  return (
    <Flex
      //w="auto"
      minW="160px"
      px="50px"
      gap="8px"
      height={{
        base: '60px',
        //xl: "85px",
        xl: isMachineUser ? '65px' : '65px'
      }}
      bgImage={`url('${COMMON_WEB_PATH}/blue-layout/header/uid_banner.png')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100%100%"
      alignItems={'center'}
      justifyContent={'center'}
      zIndex="1"
    >
      <Text
        color="transparent"
        fontSize={{
          base: 'xl',
          xl: isMachineUser ? '30px' : '30px'
        }}
        fontWeight="900"
        sx={gradientStyle}
      >
        NO.{memberInfo?.uid || '-'}
      </Text>
    </Flex>
  );
};

export default UidBanner;
